'use strict';

function generateImageUrl(image, params) {
    const imageUrl = new URL(image);
    const imageUrlParams = new URLSearchParams(imageUrl.search);
    const keys = Object.keys(params);
    keys.forEach((key) => {
        imageUrlParams.set(key, params[key]);
    });

    return `${imageUrl.origin}${imageUrl.pathname}?q=70&${imageUrlParams.toString()}`;
}

function generateImageSrcSet(image, sizesArray) {
    return sizesArray.map((size) => {
        return `${generateImageUrl(image, { sw: size })} ${size}w`;
    }).join(',');
}

module.exports = {
    generateImageUrl: generateImageUrl,
    generateImageSrcSet: generateImageSrcSet
};
